window.regularExpressions = {
    /**
     * https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
     */
    email: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
    // email: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/,
    name: /^[\w\s&.\-_']*$/,
    specialName: /^[\w\s&.\-_–'+*]*$/,
    specialChars: /[^A-Za-z0-9\s]+/,
    // specialChars: /[!@#$%^&*(+=._-]/,
}
